import { graphql } from "gatsby"
import htmr from "htmr"
import Button from "components/Button"
import { SIGNUP_URL } from "constants/urls"
import * as css from "./ApacheSupersetExpertSection.module.css"
import Section from "components/Layout/Section"
import SectionHeader from "components/Layout/SectionHeader"

function ApacheSupersetExpertSection({
  heading,
  description,
  bottomText,
  registrationButtonText,
  productPageButtonText,
}) {
  return (
    <Section className={css.root} inverted padding="heavy">
      <SectionHeader
        title={heading}
        subtitle={description}
        centered
        size="large"
        margin="light"
      />
      <div className={css.buttonGroup}>
        {registrationButtonText && (
          <Button
            className={css.firstButton}
            rounded
            color="white"
            exlarge
            href={SIGNUP_URL}
            trackClick="Get Started for free (body)_Apache Superset"
          >
            {registrationButtonText}
          </Button>
        )}
        {productPageButtonText && (
          <Button
            rounded
            color="transparent"
            exlarge
            href="/product/"
            trackClick="Learn more about Preset (body)_Apache Superset"
          >
            {productPageButtonText}
          </Button>
        )}
      </div>
      {bottomText && htmr(bottomText.childrenMarkdownRemark[0].html)}
    </Section>
  )
}

export default ApacheSupersetExpertSection

export const query = graphql`
  fragment ApacheSupersetExpertSection on ContentfulApacheSupersetExpertSection {
    id
    __typename
    heading
    description
    registrationButtonText
    productPageButtonText
    bottomText {
      childrenMarkdownRemark {
        html
      }
    }
  }
`
